import * as React from 'react';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import { passwordRegExp } from '../../utils/regExpresions';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Loading from '../Loading';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>
  </svg>
);
const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

export default function RecoveryPassword() {
  const [formPass, setFormPass] = React.useState('block');
  const [formToken, setFormToken] = React.useState('none');
  const [recoveryError, setRecoveryError] = React.useState(null);
  const [dataSubmit, setDataSubmit] = React.useState(null);
  const [passUpdate, setPassUpdate] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showPass, setShowPass] = React.useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const history = useHistory();

  const requestRecoveryToken = async (username) => {
    try {
      const res = await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_REQUEST_RECOVERY_TOKEN, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username }),
      });
      if (res.ok) {
        setFormPass('none');
        setFormToken('block');
        setLoading(false);
      } else {
        const d = await res.json();
        const errMsg = typeof d.error === 'string' ? d.error : (d.error?.message || d.message || 'Error al solicitar el token.');
        setRecoveryError(errMsg);
        setLoading(false);
      }
    } catch (err) {
      setRecoveryError(err?.message || 'Error de conexión.');
      setLoading(false);
    }
  };

  const handleSubmitToken = async (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const token = data.get('token');
    await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_RECOVER_USER, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: dataSubmit.user, recovery_token: token, new_password: dataSubmit.contraseña }),
    }).then(async (result) => {
      if (result.ok) {
        setPassUpdate(true);
        setTimeout(() => history.push('/'), 1000);
      }
    });
  };

  return (
    <>
      {loading && <Loading height="50%" width="100%" />}
      <h1>Restablecer contraseña</h1>
      <div className="ds-auth-sub">Ingresá tus datos y te enviaremos un token de recuperación al correo.</div>

      <Formik
        initialValues={{ user: '', contraseña: '', confirmarContraseña: '' }}
        validationSchema={Yup.object().shape({
          contraseña: Yup.string().required('Contraseña obligatoria').matches(passwordRegExp, 'Mín. 8 caracteres, 1 mayúscula, 1 minúscula y 1 número'),
          confirmarContraseña: Yup.string().oneOf([Yup.ref('contraseña'), null], 'Las contraseñas no coinciden').required('Confirmación obligatoria'),
        })}
        onSubmit={(data) => { setDataSubmit(data); setLoading(true); requestRecoveryToken(data.user); }}
      >
        {({ errors, handleSubmit, handleBlur, touched, values }) => (
          <>
            <form onSubmit={handleSubmit} style={{ display: formPass }}>
              <div className="ds-form-rows">
                <div className="ds-field">
                  <label>CUIT / Email</label>
                  <input className="ds-input" name="user" placeholder="Tu CUIT o correo" required onChange={e => values.user = e.target.value} onBlur={handleBlur} />
                </div>
                <div className="ds-field">
                  <label>Nueva contraseña <span className="req">*</span></label>
                  <div className="ds-input-wrap">
                    <input className={`ds-input${touched.contraseña && errors.contraseña ? ' err' : ''}`} name="contraseña" type={showPass ? 'text' : 'password'} placeholder="••••••••" onChange={e => values.contraseña = e.target.value} onBlur={handleBlur} />
                    <button type="button" className="ds-input-trail" onClick={() => setShowPass(v => !v)}>{showPass ? <EyeOffIcon /> : <EyeIcon />}</button>
                  </div>
                  {touched.contraseña && errors.contraseña && <div className="ds-helper err">{errors.contraseña}</div>}
                </div>
                <div className="ds-field">
                  <label>Confirmar nueva contraseña <span className="req">*</span></label>
                  <div className="ds-input-wrap">
                    <input className={`ds-input${touched.confirmarContraseña && errors.confirmarContraseña ? ' err' : ''}`} name="confirmarContraseña" type={showConfirm ? 'text' : 'password'} placeholder="••••••••" onChange={e => values.confirmarContraseña = e.target.value} onBlur={handleBlur} />
                    <button type="button" className="ds-input-trail" onClick={() => setShowConfirm(v => !v)}>{showConfirm ? <EyeOffIcon /> : <EyeIcon />}</button>
                  </div>
                  {touched.confirmarContraseña && errors.confirmarContraseña && <div className="ds-helper err">{errors.confirmarContraseña}</div>}
                </div>
                {recoveryError && <div className="ds-helper err">{recoveryError}</div>}
                <button type="submit" className="ds-btn ds-btn-primary ds-btn-block ds-btn-lg">Enviar token de recuperación</button>
              </div>
            </form>

            <form onSubmit={handleSubmitToken} style={{ display: formToken }}>
              <div className="ds-form-rows">
                <div className="ds-warn-note">Se ha enviado un mail con el token de recuperación al usuario registrado.</div>
                <div className="ds-field">
                  <label>Token de verificación</label>
                  <input className="ds-input" name="token" placeholder="Pegá el token recibido por mail" required />
                </div>
                <button type="submit" className="ds-btn ds-btn-primary ds-btn-block ds-btn-lg">Restablecer contraseña</button>
              </div>
            </form>
          </>
        )}
      </Formik>

      <div className="ds-auth-links" style={{ justifyContent: 'center', marginTop: 16 }}>
        <a href="#/" onClick={e => { e.preventDefault(); history.push('/'); }}>Volver a iniciar sesión</a>
      </div>

      <Snackbar open={passUpdate} autoHideDuration={6000} onClose={() => setPassUpdate(false)}>
        <Alert severity="success">Contraseña restablecida correctamente.</Alert>
      </Snackbar>
    </>
  );
}
